import React, { useCallback, useState } from 'react';
import AnalyticsWorkspaceShell from './AnalyticsWorkspaceShell';
import { buildWorkspaceDepthLinks } from './workspaceRouteModel';

function AnalyticsWorkspaceRoute({
  title,
  description,
  badge,
  icon,
  sidebarItems,
  sidebarGroups,
  sidebarHeaderActions,
  sidebarActions,
  expandActiveSectionOnly = false,
  activeSectionId,
  activeViewId,
  activeNavigationItemId,
  activeNavigationLevelId,
  activeNavigationViewId,
  activeItemAction,
  chips,
  depthLinks,
  headerAccessory,
  headerActions,
  viewSection,
  viewSectionLabel,
  filtersOpen,
  onToggleFilters,
  embedded = false,
  embeddedFilterContainer = null,
  children,
}) {
  const [filterContainer, setFilterContainer] = useState(null);
  const handleFilterHostRef = useCallback((node) => {
    setFilterContainer(node);
  }, []);
  const resolvedDepthLinks = depthLinks || buildWorkspaceDepthLinks({
    sidebarGroups,
    sidebarItems,
    activeNavigationItemId,
    activeNavigationLevelId,
  });

  if (embedded) {
    return typeof children === 'function'
      ? children({ filterContainer: embeddedFilterContainer })
      : children;
  }

  return (
    <AnalyticsWorkspaceShell
      title={title}
      description={description}
      badge={badge}
      icon={icon}
      sidebarItems={sidebarItems}
      sidebarGroups={sidebarGroups}
      sidebarHeaderActions={sidebarHeaderActions}
      sidebarActions={sidebarActions}
      expandActiveSectionOnly={expandActiveSectionOnly}
      activeSectionId={activeSectionId}
      activeViewId={activeViewId}
      activeNavigationItemId={activeNavigationItemId}
      activeNavigationLevelId={activeNavigationLevelId}
      activeNavigationViewId={activeNavigationViewId}
      activeItemAction={activeItemAction}
      chips={chips}
      depthLinks={resolvedDepthLinks}
      headerAccessory={headerAccessory}
      headerActions={headerActions}
      viewSection={viewSection}
      viewSectionLabel={viewSectionLabel}
      filtersOpen={filtersOpen}
      onToggleFilters={onToggleFilters}
      filterHostRef={handleFilterHostRef}
    >
      {typeof children === 'function'
        ? children({ filterContainer })
        : children}
    </AnalyticsWorkspaceShell>
  );
}

export default AnalyticsWorkspaceRoute;
